/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import Forms from '../../utils/forms/forms';
import batchLogService from '../../services/batchLog';
import batchLogTransformer from '../../transformers/batchLog';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      form: new Forms({
        timestamp: {
          value: '',
          type: 'date',
        },
        description: {
          value: '',
          type: 'textarea',
        },
      }),
    };
  },

  props: {
    batchId: {
      required: true,
      type: Number,
    },
    page: {
      required: true,
      type: Number,
    },
    limit: {
      required: true,
      type: Number,
    },
  },

  created() {
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const log = batchLogTransformer.send(this.form.data());
      batchLogService.store(Object.assign({}, log, { batch_id: this.batchId }), this.page, this.limit)
      .then(() => this.closeModal())
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addBatchLog/addBatchLog.js